import { SortDirection } from '@mui/material';
import { caseInsensitiveSort } from '@vxui/components';
import { Selector } from 'react-data-table-component';
import { ETranscoderProfileType, TranscoderProfile } from '@vxui/common';

export const skipNewRowSorting = <T>(rows: T[], selector: Selector<T>, direction: SortDirection) => {
  let newRow: T | null = null;
  let sortableRows = rows;

  if (rows.length > 0 && (rows[0] as TranscoderProfile).type === ETranscoderProfileType.new)
    [newRow, ...sortableRows] = rows;

  const sortedRows = caseInsensitiveSort<T>(sortableRows, selector, direction);
  if (newRow) sortedRows.unshift(newRow);

  return sortedRows;
};
